import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM17 13H7C6.448 13 6 12.552 6 12C6 11.448 6.448 11 7 11H17C17.552 11 18 11.448 18 12C18 12.552 17.552 13 17 13Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'MinusFill');

export default Icon;
